import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/Input';
import { PlaceholderCopyList } from '@/components/patientReports/PlaceholderCopyList';
import { catalogPlaceholders } from '@/lib/patientReports/placeholders';
import { TYPE } from '@/lib/typography';
import { cn } from '@/utils/cn';
import { SectionCard } from '@/pages/settings/settingsChrome';

export function PlaceholderCatalog() {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const needle = query.trim().toLocaleLowerCase('da');

  const visible = useMemo(
    () =>
      catalogPlaceholders().filter((item) => {
        if (!needle) return true;
        const description = t(item.descriptionKey).toLocaleLowerCase('da');
        return `${item.token} ${description}`.toLocaleLowerCase('da').includes(needle);
      }),
    [needle, t],
  );

  return (
    <SectionCard
      title={t('patientReports.placeholders_title')}
      subtitle={t('patientReports.placeholders_hint')}
    >
      <p className={cn(TYPE.small, 'mb-s4 text-ds-muted')}>
        {t('patientReports.placeholders_header_note')}
      </p>
      <div data-testid="placeholder-catalog" className="flex flex-col gap-s4">
        <Input
          id="patient-report-placeholder-search"
          label={t('patientReports.placeholders_search')}
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
        {visible.length === 0 ? (
          <p className={cn(TYPE.body, 'text-ds-muted')}>{t('patientReports.placeholders_empty')}</p>
        ) : (
          <PlaceholderCopyList items={visible} />
        )}
      </div>
    </SectionCard>
  );
}
